import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  addressVerificationContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '16px 24px',
    width: '100%',
    '@media(max-width: 1024px)': {
      padding: '0px',
    },
  },
  addressVerificationPaper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '24px',
    gap: '16px',
  },
  alertContainer: {
    height: 'max-content',
    width: '100%',
    display: 'flex',
    padding: '16px',
    gap: '16px',
    backgroundColor: theme.evPalette.mango[100],
    '&>.myev-MuiAlert-message': {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    '&>.myev-MuiAlert-icon': {
      padding: '10px 0',
      color: theme.evPalette.mango[700],
      justifyContent: 'center',
      margin: '0px',
    },
    '&>.myev-MuiAlert-action': {
      alignItems: 'start',
    },
  },
  reportAddressContainer: {
    display: 'flex',
    padding: '8px 0px',
    gap: '16px',
    '@media(max-width: 1024px)': {
      flexDirection: 'column',
    },
  },
  mapPinVerificationPaper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    padding: '0px 24px 24px',
    gap: '16px',
    '@media(max-width: 1024px)': {
      padding: '0px',
    },
  },
  mapContainer: {
    display: 'flex',
    position: 'relative',
    flex: '1',
    width: '100%',
    height: '72%',
    '@media(max-width: 1024px)': {
      flexDirection: 'column',
    },
  },
  mapComponent: {
    display: 'flex',
    flex: 1,
    height: '100%',
    minHeight: '627px',
    '@media(max-width: 1024px)': {
      minHeight: '300px',
    },
  },
  addressComponentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media(min-width: 1025px)': {
      borderLeft: '1px solid #B4BAC7',
      paddingLeft: '24px',
    },
  },
  confirmLocationPaper: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'absolute',
    zIndex: 150,
    left: '24px',
    right: '24px',
    padding: '16px',
    bottom: '20px',
    maxHeight: '80px',
    '@media(max-width: 1024px)': {
      maxHeight: '100%',
      zIndex: 0,
      position: 'static',
      flexDirection: 'column',
      gap: '24px',
    },
    '&>button': {
      height: '44px',
    },
  },
  mapInfoAlert: {
    padding: '16px',
    position: 'static',
    height: 'min-content',
    alignItems: 'center',
    '@media(min-width: 1025px)': {
      height: '56px',
      position: 'absolute',
      zIndex: 100,
      top: '20px',
      left: '28px',
      right: '28px',
    },
  },
  mapInfoAlertText: { fontSize: '16px', color: '#1B202C' },
  reportTypeText: {
    color: theme.evPalette.charcoal[800],
    fontSize: '16px',
  },
  redirectionLinkText: {
    gap: '4px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
  },
  redirectionButtonStyles: {
    color: theme.evPalette.ocean[600],
    fontSize: '16px',
    fontWeight: 400,
    padding: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  errorAlert: {
    backgroundColor: theme.evPalette.rose[100],
    borderBottom: `1px solid ${theme.evPalette.rose[900]}`,
    borderRadius: 0,
  },
  errorAlertIcon: { '& svg': { color: theme.evPalette.rose[900] } },
}));
